import { Injectable } from '@angular/core';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { companyMortgageCommand } from '../../command/company-mortgage.command';
import { AddAmortizationCommandHandler } from './add-amortization-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';

@Injectable()
export class CompanyMortgageCommandHandlerResolver extends CommandHandlerResolver {
  constructor(deleteHandler: DeleteCommandHandler, editHandler: EditCommandHandler, addAmortizationHandler: AddAmortizationCommandHandler) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(companyMortgageCommand.addAmortization, addAmortizationHandler);
  }
}

@Injectable()
export class CompanyMortgageFormCommandHandlerResolver extends CommandHandlerResolver {
  constructor(
    deleteHandler: DeleteFormCommandHandler,
    createHandler: CreateCommandHandler,
    addAmortizationHandler: AddAmortizationCommandHandler
  ) {
    super();
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.create, createHandler);
    this.addHandler(companyMortgageCommand.addAmortization, addAmortizationHandler);
  }
}
